import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Plus, Truck, Car } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import DeliveryDialog from './DeliveryDialog';

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const [showDeliveryDialog, setShowDeliveryDialog] = useState(false);
  const navRef = useRef(null);

  // Measure footer height and set CSS custom property
  useEffect(() => {
    const navElement = navRef.current;
    if (!navElement) return;

    const updateFooterHeight = () => {
      const height = navElement.offsetHeight;
      document.documentElement.style.setProperty('--footer-h', `${height}px`);
    };

    // Initial measurement
    updateFooterHeight();

    // Watch for size changes
    const resizeObserver = new ResizeObserver(updateFooterHeight);
    resizeObserver.observe(navElement);

    return () => {
      resizeObserver.disconnect();
      document.documentElement.style.removeProperty('--footer-h');
    };
  }, []);

  // Admin ve Owner kullanıcıları için bottom nav gösterme
  if (user?.username === 'admin' || user?.isOwner) {
    return null;
  }

  // Vehicle call sayfasında gösterme
  if (location.pathname.startsWith('/call')) {
    return null;
  }

  const handleDeliverySuccess = () => {
    // Eğer vehicles sayfasındaysak, sayfayı yenile
    if (location.pathname === '/vehicles') {
      window.location.reload();
    }
  };

  return (
    <>
      {/* Mobile Fixed Bottom Navigation - Staff Only */}
      <div
        ref={navRef}
        className="md:hidden fixed bottom-0 left-0 right-0 bg-white/90 backdrop-blur-md border-t border-gray-200 z-[9999]"
        style={{
          paddingBottom: 'env(safe-area-inset-bottom, 0px)',
          paddingLeft: 'max(1rem, env(safe-area-inset-left, 0px))',
          paddingRight: 'max(1rem, env(safe-area-inset-right, 0px))',
          paddingTop: '1rem'
        }}
      >
        <div className="flex gap-3">
          <button
            onClick={() => {
              setShowDeliveryDialog(true);
            }}
            className="flex-1 bg-gray-600 hover:bg-gray-700 text-white px-4 min-h-[48px] rounded-lg flex flex-col items-center justify-center font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 active:scale-95"
          >
            <Truck className="w-6 h-6 text-white" />
          </button>

          <button
            onClick={() => {
              setShowDeliveryDialog(false);
              navigate('/vehicles');
            }}
            className="flex-1 bg-purple-600 hover:bg-purple-700 text-white px-4 min-h-[48px] rounded-lg flex flex-col items-center justify-center font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 active:scale-95"
          >
            <Car className="w-6 h-6 text-white" />
          </button>

          <button
            onClick={() => {
              setShowDeliveryDialog(false);
              navigate('/vehicles/new');
            }}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-4 min-h-[48px] rounded-lg flex flex-col items-center justify-center font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 active:scale-95"
          >
            <Plus className="w-6 h-6 text-white" />
          </button>
        </div>
      </div>

      {/* Delivery Dialog - Staff Only */}
      <DeliveryDialog
        isOpen={showDeliveryDialog}
        onClose={() => setShowDeliveryDialog(false)}
        onDeliverySuccess={handleDeliverySuccess}
      />
    </>
  );
};

export default MobileBottomNav;